










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getLanguagesHelper } from '@/heplers';
import LanguageInfo from './LanguageInfo.vue';
import { parseHrefHelper } from '@/heplers/stringHelpers';

@Component({
  components: {
    LanguageInfo,
  },
  filters: {
    parseHref: (url: string) => {
      return parseHrefHelper(url, '/docs/');
    },
    getLanguages: getLanguagesHelper,
  },
})
export default class BlogLink extends Vue {
  @Prop() link: any;
}
